import React, { createContext, useContext, useState, useEffect } from "react";

const StatusFilterContext = createContext(null);

export function StatusFilterProvider({ children }) {
  const [status, setStatus] = useState(() => {
    try { return localStorage.getItem("imeak_status_filter") || "faal"; } catch { return "faal"; }
  });
  useEffect(() => {
    try { localStorage.setItem("imeak_status_filter", status); } catch { /* ignore */ }
  }, [status]);
  return (
    <StatusFilterContext.Provider value={{ status, setStatus }}>
      {children}
    </StatusFilterContext.Provider>
  );
}

export function useStatusFilter() {
  const ctx = useContext(StatusFilterContext);
  return ctx || { status: "faal", setStatus: () => {} };
}
